import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractMaintenanceParticipanceListStatus: 'idle',
    loadContractMaintenanceParticipanceListError: undefined as any,
    loadContractMaintenanceParticipanceListLastArgs: undefined as any,
    loadMaintenanceParticipanceRentStatus: 'idle',
    loadMaintenanceParticipanceRentError: undefined as any,
    saveMaintenanceParticipanceRentStatus: 'idle',
    saveMaintenanceParticipanceRentError: undefined as any,
    deleteMaintenanceParticipanceRentStatus: 'idle',
    deleteMaintenanceParticipanceRentError: undefined as any,

    vtgihbetList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractMaintenanceParticipanceList = createAsyncThunk('vtgihbetSlice/loadContractMaintenanceParticipanceList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().vtgihbetSlice.loadContractMaintenanceParticipanceListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/vtgihbet/?action=gte&MIN_FLBELID=${parentModel.HDR_ID}&MAX_FLBELID=${parentModel.HDR_ID}&MIN_LBEGINDAT=${parentModel.BEGIN}&MAX_LBEGINDAT=${parentModel.BEGIN}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractMaintenanceParticipanceListStatus } = getState().vtgihbetSlice
        return loadContractMaintenanceParticipanceListStatus !== 'pending'
    }
})

export const loadMaintenanceParticipanceRent = createAsyncThunk('vtgihbetSlice/loadMaintenanceParticipanceRent', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/vtgihbet/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMaintenanceParticipanceRentStatus } = getState().vtgihbetSlice
        return loadMaintenanceParticipanceRentStatus !== 'pending'
    }
})

export const saveMaintenanceParticipanceRent = createAsyncThunk('vtgihbetSlice/saveMaintenanceParticipanceRent', async ({ vtgihbet }: any, { rejectWithValue }: any) => {
    let promises = []
    if (vtgihbet?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/vtgihbet/${ vtgihbet?.HDR_ID }/`,
            prepareData(vtgihbet),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/vtgihbet/`,
            prepareData(vtgihbet),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMaintenanceParticipanceRentStatus } = getState().vtgihbetSlice
        return saveMaintenanceParticipanceRentStatus !== 'pending'
    }
})

export const deleteMaintenanceParticipanceRent = createAsyncThunk('vtgihbetSlice/deleteMaintenanceParticipanceRent', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/vtgihbet/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMaintenanceParticipanceRentStatus } = getState().vtgihbetSlice
        return deleteMaintenanceParticipanceRentStatus !== 'pending'
    }
})

const VtgihbetSlice = createSlice({
    name: 'vtgihbetSlice',
    initialState,
    reducers: {
        resetloadContractMaintenanceParticipanceListError: (state) => {
            state.loadContractMaintenanceParticipanceListError = undefined
        },
        resetloadMaintenanceParticipanceRent: (state) => {
            state.formItem = undefined
            state.loadMaintenanceParticipanceRentError = undefined
        },
        resetloadMaintenanceParticipanceRentError: (state) => {
            state.loadMaintenanceParticipanceRentError = undefined
        },
        resetsaveMaintenanceParticipanceRent: (state) => {
            state.formItem = undefined
            state.saveMaintenanceParticipanceRentError = undefined
        },
        resetsaveMaintenanceParticipanceRentError: (state) => {
            state.saveMaintenanceParticipanceRentError = undefined
        },
        resetdeleteMaintenanceParticipanceRentError: (state) => {
            state.deleteMaintenanceParticipanceRentError = undefined
        },
        removeFromVtgihbetListById: (state, action) => {
            state.vtgihbetList = state.vtgihbetList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromVtgihbetListByIds: (state, action) => {
            state.vtgihbetList = state.vtgihbetList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.vtgihbetList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractMaintenanceParticipanceListStatus = 'preloaded'
            state.loadContractMaintenanceParticipanceListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.vtgihbetList = []
            state.loadContractMaintenanceParticipanceListStatus = 'idle'
            state.loadContractMaintenanceParticipanceListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractMaintenanceParticipanceList.pending, (state) => {
            state.loadContractMaintenanceParticipanceListStatus = 'pending'
            state.loadContractMaintenanceParticipanceListError = undefined
        })
        builder.addCase(loadContractMaintenanceParticipanceList.fulfilled, (state, action) => {
            state.loadContractMaintenanceParticipanceListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractMaintenanceParticipanceListLastArgs = action.payload.args

            {
                state.vtgihbetList = action.payload.data

            }
        })
        builder.addCase(loadContractMaintenanceParticipanceList.rejected, (state, action) => {
            state.loadContractMaintenanceParticipanceListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractMaintenanceParticipanceListError = action.error.message
            } else {
                state.loadContractMaintenanceParticipanceListError = action.payload
            }
        })

        builder.addCase(loadMaintenanceParticipanceRent.pending, (state) => {
            state.loadMaintenanceParticipanceRentStatus = 'pending'
            state.loadMaintenanceParticipanceRentError = undefined
        })
        builder.addCase(loadMaintenanceParticipanceRent.fulfilled, (state, action) => {
            state.loadMaintenanceParticipanceRentStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.vtgihbetList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.vtgihbetList.push(newItem) }
                else { state.vtgihbetList[i] = { ...state.vtgihbetList[i], ...newItem } }
            }
        })
        builder.addCase(loadMaintenanceParticipanceRent.rejected, (state, action) => {
            state.loadMaintenanceParticipanceRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMaintenanceParticipanceRentError = action.error.message
            } else {
                state.loadMaintenanceParticipanceRentError = action.payload
            }
        })

        builder.addCase(saveMaintenanceParticipanceRent.pending, (state) => {
            state.saveMaintenanceParticipanceRentStatus = 'pending'
            state.saveMaintenanceParticipanceRentError = undefined
        })
        builder.addCase(saveMaintenanceParticipanceRent.fulfilled, (state, action) => {
            state.saveMaintenanceParticipanceRentStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.vtgihbetList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.vtgihbetList.push(newItem) }
                else { state.vtgihbetList[i] = { ...state.vtgihbetList[i], ...newItem } }
            }
        })
        builder.addCase(saveMaintenanceParticipanceRent.rejected, (state, action) => {
            state.saveMaintenanceParticipanceRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMaintenanceParticipanceRentError = action.error.message
            } else {
                state.saveMaintenanceParticipanceRentError = action.payload
            }
        })

        builder.addCase(deleteMaintenanceParticipanceRent.pending, (state) => {
            state.deleteMaintenanceParticipanceRentStatus = 'pending'
            state.deleteMaintenanceParticipanceRentError = undefined
        })
        builder.addCase(deleteMaintenanceParticipanceRent.fulfilled, (state, action) => {
            state.deleteMaintenanceParticipanceRentStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.vtgihbetList = state.vtgihbetList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.vtgihbetList = state.vtgihbetList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMaintenanceParticipanceRent.rejected, (state, action) => {
            state.deleteMaintenanceParticipanceRentStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMaintenanceParticipanceRentError = action.error.message
            } else {
                state.deleteMaintenanceParticipanceRentError = action.payload
            }
        })

    }
})

export const {
    resetloadContractMaintenanceParticipanceListError,
    resetloadMaintenanceParticipanceRent,
    resetloadMaintenanceParticipanceRentError,
    resetsaveMaintenanceParticipanceRent,
    resetsaveMaintenanceParticipanceRentError,
    resetdeleteMaintenanceParticipanceRentError,
    removeFromVtgihbetListById,
    removeFromVtgihbetListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = VtgihbetSlice.actions
export default VtgihbetSlice.reducer
